module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/cloud/sorority-cloud-01-medium-ab6bd4905cf733503011a091328ddcb4.jpg";